import { makeAPaymentReferenceData, makeAPaymentCardDetail, makePayment, paymentSuccessReferenceData } from '@/constants/MyCoverServicesMockApiData';
import { AwaitResponse } from '@general/js/utils/MockUtils';
import PaymentsAbstractServices from './PaymentsAbstractServices';

export default class PaymentsServices extends PaymentsAbstractServices {
  static getMakeAPaymentMaximumAmount() {
    return AwaitResponse(123.12);
  }

  /** return mock data for make a payment page reference data */
  static getMakeAPaymentReferenceData() {
    return AwaitResponse(JSON.parse(JSON.stringify(makeAPaymentReferenceData).tokenSwap()));
  }

  /** return mock data for the payment success page */
  static getPaymentSuccessReferenceData() {
    return AwaitResponse(paymentSuccessReferenceData);
  }

  /** return mock data for credit card detail */
  static getCardDetail() {
    return AwaitResponse(makeAPaymentCardDetail);
  }

  static getReferenceData() {
    return AwaitResponse(
      JSON.parse(
        JSON.stringify({
          referenceData: {
            paymentsInformationFullAccessText: {
              informationText:
                '<p>Keep track of your premium payments. You will see direct debit and credit card payments by the next business day. BPAY payments can take up to 3 business days to appear in your payment history.<br /><br />\r\n<strong>Never miss a payment</strong><br />Keep your&nbsp;<a href="/$memberNumber$/payment-selection"> payment details</a> up to date, or set up a direct debit (if you haven&#39;t already) for automatic payments this will also mean your payments will be automatically updated&nbsp;if you make a change to your&nbsp;cover that changes your&nbsp;premium.</p>',
            },
            paymentsInformationSelfAccessText: {
              informationText:
                '<p>Keep track of the premium payments you make.<br /><br />You will see direct debit and credit card payments by the next business day. BPAY payments can take up to 3 business days to appear in your payment history.<br /><br />Policy holders and members with&nbsp;full access can see a complete payment history.</p>',
            },
            paymentsCallOutText: {
              informationText:
                '<h2>This membership is covered until #{paidToDate}</h2>\r\n\r\n<p>Premiums are paid in advance. If&nbsp;for some reason payment is in&nbsp;arrears, benefits cannot be paid,&nbsp;so be sure to make a payment or to call us.</p>\r\n',
            },
            paymentsLaterCallOutText: {
              informationText:
                '<h2>This membership will be covered&nbsp;from #{coverStartDate}</h2>\r\n\r\n<p>Premiums are paid in advance.&nbsp;For your claims to be paid, your&nbsp;account must be in credit. Use&nbsp;the&nbsp;<a href="/$memberNumber$/my-cover/Premium-calculator">premium calculator</a>&nbsp;to&nbsp;calculate your payment amount.</p>\r\n',
            },
            paymentsCallOutIcon: {
              informationText: '~/assets/public/images/icon_add.svg',
            },
          },
          datePaidTo: '2022-09-30',
          coverStartDate: '2021-11-10',
        }).tokenSwap(),
      ),
    );
  }

  static getPayments() {
    return AwaitResponse({
      payments: [
        {
          referenceId: '0000011',
          datePaid: '2020-05-06',
          amount: 300.0,
          paymentDescription: 'Reversal of payment done by Cheque/Money Order',
          paymentMethod: 'CHQMORP',
        },
        {
          referenceId: '0000012',
          datePaid: '2020-07-21',
          amount: 30.0,
          paymentDescription: 'Reversal of a payment done by EFT',
          paymentMethod: 'EFTRP',
        },
        {
          referenceId: '0000013',
          datePaid: '2020-04-03',
          amount: 300.0,
          paymentDescription: 'Payment done by Cheque/Money Order',
          paymentMethod: 'CHQMOP',
        },
        {
          referenceId: '0000004',
          datePaid: '2022-04-10',
          amount: 52.1,
          paymentDescription: 'Payment done by EFT',
          paymentMethod: 'EFTP',
        },
        {
          referenceId: '0000005',
          datePaid: '2020-04-10',
          amount: 50,
          paymentDescription: 'Credit Card Authorisation Surcharge for a immediate contribution payment.',
          paymentMethod: 'CCASP',
        },
        {
          referenceId: '0000024',
          datePaid: '2021-11-17',
          amount: 50.4,
          paymentDescription: 'Credit Card Authorisation Surcharge for a immediate contribution payment.',
          paymentMethod: 'CCASP',
        },
        {
          referenceId: '0000345',
          datePaid: '2021-09-10',
          amount: 594.49,
          paymentDescription: 'Reversal of Credit Card Direct Debit Surcharge for a contribution payment.',
          paymentMethod: 'DDCCSRP',
        },
        {
          referenceId: '0000105',
          datePaid: '2021-09-01',
          amount: 102.93,
          paymentDescription: 'Staff Payroll Payment',
          paymentMethod: 'STAFFP',
        },
        {
          referenceId: '0000495',
          datePaid: '2021-09-01',
          amount: 40.87,
          paymentDescription: 'Staff Payroll Payment',
          paymentMethod: 'STAFFP',
        },
        {
          referenceId: '0001000',
          datePaid: '2022-09-01',
          amount: 200.87,
          paymentDescription: 'Reversal of Credit Card Surcahge payment (authorisation) for a IVR contribution payment.',
          paymentMethod: 'CCIVRSRP',
        },
        {
          referenceId: '0000195',
          datePaid: '2022-09-03',
          amount: 40.87,
          paymentDescription: 'Reversal of a BPay contribution payment.',
          paymentMethod: 'BPAYRP',
        },
        {
          referenceId: '0000111',
          datePaid: '2020-05-18',
          amount: 300.43,
          paymentDescription: 'Reversal of Credit Card Surcahge payment (authorisation) for a IVR contribution payment.',
          paymentMethod: 'CCIVRSRP',
        },
        {
          referenceId: '0000212',
          datePaid: '2021-11-22',
          amount: 30,
          paymentDescription: 'Reversal of a BPay contribution payment.',
          paymentMethod: 'BPAYRP',
        },
        {
          referenceId: '0000313',
          datePaid: '2020-03-14',
          amount: 74.58,
          paymentDescription: 'BPay contribution payment.',
          paymentMethod: 'BPAYP',
        },
        {
          referenceId: '0000032',
          datePaid: '2022-04-10',
          amount: 52.1,
          paymentDescription: 'Reversal of a bill that was sent out for advising contribution payment required.',
          paymentMethod: 'BILLRP',
        },
        {
          referenceId: '1000032',
          datePaid: '2022-03-11',
          amount: 19.31,
          paymentDescription: 'Reversal of a bill that was sent out for advising contribution payment required.',
          paymentMethod: 'BILLRP',
        },
        {
          referenceId: '0003032',
          datePaid: '2021-01-09',
          amount: 7,
          paymentDescription: 'Reversal of a bill that was sent out for advising contribution payment required.',
          paymentMethod: 'BILLRP',
        },
        {
          referenceId: '0001234',
          datePaid: '2021-07-06',
          amount: 16.8,
          paymentDescription: 'Reversal of a bill that was sent out for advising contribution payment required.',
          paymentMethod: 'BILLRP',
        },
        {
          referenceId: '0000932',
          datePaid: '2022-04-10',
          amount: 73.1,
          paymentDescription: 'Reversal of a bill that was sent out for advising contribution payment required.',
          paymentMethod: 'BILLRP',
        },
        {
          referenceId: '0000547',
          datePaid: '2020-04-10',
          amount: 67.99,
          paymentDescription: 'Credit Card Authorisation for a immediate contribution payment.',
          paymentMethod: 'CCAOLP',
        },
        {
          referenceId: '0000887',
          datePaid: '2021-09-11',
          amount: 52.1,
          paymentDescription: 'Refund to be Held On-Account',
          paymentMethod: 'HDRFND',
        },
        {
          referenceId: '0000432',
          datePaid: '2021-10-11',
          amount: 18.21,
          paymentDescription: 'Refund actually paid to bank account.',
          paymentMethod: 'PDRFND',
        },
      ],
    });
  }

  static getPaymentsDocument() {
    return AwaitResponse({
      file: {
        link: 'https://google.com.au',
      },
    });
  }

  static makePayment() {
    return AwaitResponse(makePayment);
  }
}
